import React from 'react';
import { useSelector } from 'react-redux';
import { Accordion } from '@noths/polaris-client-ribbons-design-system';

import type { ReduxApplicationState } from 'src/redux/types';
import * as styles from './DeliveryFAQs.styles';

const ACCORDION_ID_PREFIX = 'delivery-faq';

const getAccordionId = (question: string) => {
  return `${ACCORDION_ID_PREFIX}-${question.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
};

export const DeliveryFAQs = () => {
  const deliveryFAQs = useSelector((state: ReduxApplicationState) => state.content.deliveryFAQs);

  if (!deliveryFAQs || deliveryFAQs.items.length === 0) {
    return null;
  }

  return (
    <section aria-label={deliveryFAQs.heading} css={styles.root}>
      <h2>{deliveryFAQs.heading}</h2>
      <ul css={styles.questions}>
        {deliveryFAQs.items.map((item) => (
          <li key={item.question}>
            <Accordion
              id={getAccordionId(item.question)}
              open={false}
              title={<h3>{item.question}</h3>}
            >
              <div css={styles.answer} dangerouslySetInnerHTML={{ __html: item.answer }} />
            </Accordion>
          </li>
        ))}
      </ul>
    </section>
  );
};
